// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__rHi-n","col":"styles_col__1BRlO"};